import React from 'react';
import * as R from 'ramda';
import { FormattedMessage } from 'react-intl';
import { useLabels } from '~/utils';

export default ({ order }) => {
  const label = useLabels();

  if (!order || !order.owner) return null;

  const { fullname, email, phone, mobile } = order.owner;

  const manager = order?.manager;

  const divisionName = R.path(['division', 'name'], order);

  if (!(fullname || email || phone || mobile || divisionName)) return null;

  return (
    <>
      <h2>
        {' '}
        <FormattedMessage
          id="contactdetails-header"
          defaultMessage="Contact details"
        />
      </h2>

      <ul className="trade-details-list personal-details">
        {divisionName && (
          <li className="reversed">
            <strong>
              {label(
                'division',
                <FormattedMessage
                  id="contactdetails-field-division-label"
                  defaultMessage="Division"
                />
              )}
            </strong>
            <span>{divisionName}</span>
          </li>
        )}
        {fullname && (
          <li className="reversed">
            <strong>
              <FormattedMessage
                id="contactdetails-field-name-label"
                defaultMessage="Name"
              />
            </strong>
            <span>{fullname}</span>
          </li>
        )}
        {email && (
          <li className="reversed">
            <strong>
              <FormattedMessage
                id="contactdetails-field-email-label"
                defaultMessage="Email"
              />
            </strong>
            <span>
              <a href={`mailto:${email}`} title={`${email}`}>
                {email}
              </a>
            </span>
          </li>
        )}
        {phone && (
          <li className="reversed">
            <strong>
              <FormattedMessage
                id="contactdetails-field-phone-label"
                defaultMessage="Phone"
              />
            </strong>
            <span className="nowrap">{phone}</span>
          </li>
        )}
        {mobile && (
          <li className="reversed">
            <strong>
              <FormattedMessage
                id="contactdetails-field-mobile-label"
                defaultMessage="Mobile"
              />
            </strong>
            <span className="nowrap">{mobile}</span>
          </li>
        )}
        {manager && (
          <li className="reversed">
            <strong>
              <FormattedMessage
                id="contactdetails-field-manager-label"
                defaultMessage="Account manager"
              />
            </strong>
            <span className="nowrap">{manager.fullname || manager.name}</span>
          </li>
        )}
      </ul>
    </>
  );
};
